import styled from "@emotion/styled";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { compareDesc, format } from "date-fns";
import { EmployeeTrainingStatus } from "../../constants";
import { ReactComponent as AttachmentIcon } from "../../resources/images/icons-attachment.svg";
import { ReactComponent as MoreVertIcon } from "../../resources/images/icons-more-vertical.svg";
import { KLAYO_COLORS } from "../../themes";
import { Tooltip } from "../Tooltip";
import { Table } from "./Table";

export class ProfileTrainingTable extends Table {
  static columns = {
    completedDate: {
      field: "completedDate",
      label: "COMPLETED"
    },
    name: {
      field: "TRAINING",
      label: "NAME"
    },
    type: {
      field: "type",
      label: "TYPE"
    },
    competencies: {
      field: "competencies",
      label: "COMPETENCIES"
    },
    status: {
      field: "status",
      label: "STATUS"
    },
    actions: {
      field: "actions",
      label: ""
    },
    moreActions: {
      field: "actions",
      label: ""
    },
    attachmentIcon: {
      field: "attachmentIcon",
      label: "Attachment"
    }
  };

  static defaultProps: any = {
    ...Table.defaultProps,
    columns: [
      { type: ProfileTrainingTable.columns.completedDate },
      { type: ProfileTrainingTable.columns.type },
      { type: ProfileTrainingTable.columns.name },
      { type: ProfileTrainingTable.columns.status },
      { type: ProfileTrainingTable.columns.actions }
    ],
    noRowsMessage: null,
    rowHasAction: null
  };

  constructor(props: any) {
    super(props);
  }

  getRowId(e: any) {
    return this.tableId + "_" + e.id;
  }
  onRowClick(params: any, e: any) {
    const { onRowSelect } = this.props;
    if (params.row && onRowSelect) onRowSelect(e, params.row);
  }
  handleOnOpenAttributesDialog = (value: any, type: any) => {
    const { onOpenTaskAttributesDialog } = this.props;
    onOpenTaskAttributesDialog(value, type);
  };

  initColumns() {
    const { columns, sortable, rowHasAction, rowNoActionIcon, readOnly } = this.props;

    this.columns = [];

    columns.forEach((c: any) => {
      if (this.hasColumn(c)) {
        if (c.type === ProfileTrainingTable.columns.completedDate)
          this.columns.push({
            field: "completedDate",
            sortable: sortable,
            headerName: c.label || c.type.label,
            width: 140,
            disableReorder: true,
            valueGetter: (params: any) => format(new Date(params.row.completedDate), "dd-MMM-yyyy"),
            sortComparator: (d1: any, d2: any) => compareDesc(new Date(d2), new Date(d1))
          });
        if (c.type === ProfileTrainingTable.columns.type)
          this.columns.push({
            field: "type",
            sortable: sortable,
            headerName: c.label || c.type.label,
            width: 120,
            disableReorder: true,
            valueGetter: (params: any) => params.row.type
          });

        if (c.type === ProfileTrainingTable.columns.name)
          this.columns.push({
            field: "courseName",
            sortable: sortable,
            headerName: c.label || c.type.label,
            disableReorder: true,
            flex: 1,
            filterable: false,
            valueGetter: (params: any) => params.row.name
            // `${params.row.name} | ${params.row.organizationIntegrationAbbreviation}`
          });
        if (c.type === ProfileTrainingTable.columns.status)
          this.columns.push({
            field: "status",
            sortable: sortable,
            headerName: c.label || c.type.label,
            width: 220,
            disableReorder: true,
            valueGetter: (params: any) => params.row.status
          });

        if (c.type === ProfileTrainingTable.columns.actions && !readOnly)
          this.columns.push({
            field: "actions",
            type: "actions",
            filterable: false,
            align: "right",
            width: 50,
            disableReorder: true,
            getActions: (params: any) => [
              rowHasAction && rowHasAction(params.row) ? (
                params.row.isTraining &&
                params.row.statusValue !== EmployeeTrainingStatus.Approved ? (
                  <GridActionsCellItem
                    icon={<MoreVertIcon />}
                    label='Actions'
                    onClick={(e) => this.props.onRowAction(e, params.row)}
                  />
                ) : (
                  <></>
                )
              ) : rowNoActionIcon ? (
                <Tooltip title='Under review' placement='right'>
                  {rowNoActionIcon}
                </Tooltip>
              ) : (
                <div></div>
              )
            ]
          });
        if (c.type === ProfileTrainingTable.columns.moreActions)
          this.columns.push({
            field: "actions",
            type: "actions",
            filterable: false,
            align: "right",
            width: 50,
            disableReorder: true,
            getActions: (params: any) => [
              ...((params.row.hasActions ?? true)
                ? [
                    <GridActionsCellItem
                      icon={<MoreVertIcon />}
                      label='Actions'
                      onClick={(e) => {
                        this.props.onRowAction(e, params.row);
                      }}
                      key={Math.random().toString(36).substring(7)}
                    />
                  ]
                : [])
            ]
          });

        if (c.type === ProfileTrainingTable.columns.attachmentIcon)
          this.columns.push({
            field: "attachmentIcon",
            headerName: "",
            visibleFromBreakpoint: c.visibleFromBreakpoint || c.type.visibleFromBreakpoint,
            width: 44,
            minWidth: 44,
            renderCell: (params: any) =>
              params.row.hasDocuments && <AttachmentIcon className='klayo-attrtable_attachment' />
          });
        // if (c.type === ProfileTrainingTable.columns.competencies)
        //   this.columns.push({
        //     field: "competencies",
        //     sortable: sortable,
        //     width: 120,
        //     filterable: false,
        //     headerName: c.label || c.type.label,
        //     disableReorder: true,
        //     renderCell: (params: any) => {
        //       const competencies = params.row.associatedCompetencies;
        //       return (
        //         <div style={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
        //           <KlayoTag
        //             isTag={competencies.length !== 0}
        //             onClick={(event: any) => {
        //               event.stopPropagation();
        //               if (competencies.length > 0) showDialog(params.row);
        //             }}
        //           >
        //             {competencies.length}
        //           </KlayoTag>
        //         </div>
        //       );
        //     },
        //     valueGetter: (params: any) => {
        //       return params.row.associatedCompetencies?.length;
        //     }
        //   });
      }
    });
  }
}

const KlayoTag = styled.div<any>`
  padding: 2px 12px;
  background-color: ${(props) =>
    props.isTag ? KLAYO_COLORS.NeonBlueNB050 : KLAYO_COLORS.transparent};
  border-radius: 100px;

  color: ${(props) => (props.isTag ? KLAYO_COLORS.NeonBlueNB500 : KLAYO_COLORS.GreyGR900)};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  :hover {
    filter: ${(props) => (props.isTag ? "brightness(95%)" : "")};
    cursor: ${(props) => (props.isTag ? "pointer" : "")};
  }

  :focus {
    background-color: ${(props) => (props.isTag ? "#c6c7fc" : "")};
  }
`;
